import { Action,applyMiddleware, combineReducers, createStore  } from 'redux'
import thunk, { ThunkDispatch, ThunkMiddleware } from 'redux-thunk'
import { composeWithDevTools } from "redux-devtools-extension";
import signUp from './reducer/signUp';
import DataReducer from './reducer/DataReducer';
import { useDispatch, useSelector } from 'react-redux';
import { userReducer } from './actions/DataAction';
import { taskReducer } from './reducer/TaskReducer';
import adminViewReducer from './reducer/organization/AdminReducer';
import pricingReducer from './reducer/pricingReducer';
import roleReducer from './reducer/settingsRoleReducer';
import { userFeedbackReducer } from './reducer/UserFeedbackReducer';
import helpReducer from './reducer/HelpReducer';
import otpReducer from './reducer/otpReducer';
import companyReducer from './reducer/organization/CompanyReducer';
import stripeReducer from './reducer/StripeReducer';
import { timeManagementReducer } from './reducer/TimeManagementReducer';
import SecurityReducer from './reducer/SecurityReducer';
import { sidePanelReducer } from './reducer/sidePanelReducer';
import whiteLabelReducer from './reducer/organization/whiteLabelReducer';
import { employeeReducer } from './reducer/organization/employeeReducer';
import { teamReducer } from './reducer/organization/teamReducer';
import { aistudioReducer } from './reducer/AIStudioReducer';
import documentSignReducer from './reducer/documentSignReducer';
import { lawyerReducer } from './reducer/LawyerReducer';
import { subscriptionReducer } from './reducer/SubscriptionReducer';
import tablesReducer from './reducer/tablesReducer';
import notificationsReducer from '../components/Notifications/notificationSlice'
import orgDefaultCurrencyReducer from './slices/orgDefaultCurrencySlice';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import signIn from './reducer/signIn';
import modelReducer from './reducer/chatReducer';
import { clientReducer } from './reducer/ClientReducer';
import documentReducer from './reducer/documentsReducer';
import { draftReducer } from './reducer/Drafts/DraftReducer';
import dropdownReducer from './reducer/DropdownReducer';
import feedbackReducer from './reducer/feedbackReducer';
import folderReducer from './reducer/folderReducer';
import { modalReducer } from './reducer/modalReducer';
import sidebarReducer from './reducer/SidebarReducer';
import { departmentReducer } from './reducer/organization/DepartmentReducer';
import engagementLetterReducer from './reducer/Drafts/EngagementLetterReducer';
import { pipelineReducer } from './reducer/Pipeline/PipelineReducer';
import caseCreationReducer from './reducer/caseCreationReducer';
import { templateReducer } from './reducer/TemplateReducer';
import { matterReducer } from './reducer/Matters/MatterReducer';
import { matterDraftReducer } from './reducer/Drafts/MatterDraftReducer';
import { matterInsightReducer } from './reducer/Insights/matterInsightReducer';
import onboardingReducer from './reducer/OnboardingReducer';
import orgPeopleReducer from './reducer/orgPeopleReducer';
import menuReducer from './reducer/menuReducer';
import batchTablesReducer from './reducer/BatchTables/batchTablesReducer';
import reviewReducer from './reducer/Review/reviewReducer';
import { licenseReducer } from './reducer/licenseReducer';
import { calendarReducer } from './reducer/CalendarReducer';
import { dashboardReducer } from './reducer/DashboardReducer';
import financeReducer from './reducer/FinanceReducer';
import { tourReducer } from './reducer/TourReducer';
import projectReducer from './reducer/Projects/projectReducer';
import draftingReducer from './slices/draftingSlice';



const rootReducer = combineReducers({
    signUp: signUp,
    pricing: pricingReducer,
    auth: signIn,
    lists: DataReducer,
    documents: documentReducer,
    folders: folderReducer,
    model: modelReducer,
    user: userReducer,
    feedback: feedbackReducer,
    modal: modalReducer,
    tasks: taskReducer,
    adminView: adminViewReducer,
    role: roleReducer,
    userFeedback: userFeedbackReducer,
    sidebar: sidebarReducer,
    help: helpReducer,
    otp: otpReducer,
    company: companyReducer,
    stripe: stripeReducer,
    time: timeManagementReducer,
    client: clientReducer,
    security: SecurityReducer,
    dropdown: dropdownReducer,
    sidePanel: sidePanelReducer,
    whiteLabel: whiteLabelReducer,
    employees: employeeReducer,
    teams: teamReducer,
    aistudio: aistudioReducer,
    signdoc: documentSignReducer,
    lawyer: lawyerReducer,
    subscription: subscriptionReducer,
    tables: tablesReducer,
    pipelineSeb: pipelineReducer,
    draft: draftReducer,
    notifications: notificationsReducer,
    departments: departmentReducer,
    engagementLetter: engagementLetterReducer,
    pipeline: pipelineReducer,
    caseCreation: caseCreationReducer,
    templates: templateReducer,
    matters: matterReducer,
    matterDraft: matterDraftReducer,
    matterInsights: matterInsightReducer,
    onboarding: onboardingReducer,
    orgPeople: orgPeopleReducer,
    menu: menuReducer,
    batchTables: batchTablesReducer,
    review: reviewReducer,
    license: licenseReducer,
    calendar: calendarReducer,
    dashboard: dashboardReducer,
    finance: financeReducer,
    tour: tourReducer,
    projects: projectReducer,
    orgDefaultCurrency: orgDefaultCurrencyReducer,
    drafting: draftingReducer,
})


export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = ThunkDispatch<RootState, any, Action>;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector = (selector: (state: RootState) => any) => useSelector(selector);

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'user'], // menu is now static (config/defaultMenu.ts) - no need to persist
};

const persistedReducer = persistReducer<RootState, any>(
  persistConfig,
  rootReducer
);

const middleware = [thunk as ThunkMiddleware<RootState>];


const store = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(...middleware))
);

export const persistor = persistStore(store);

export default store;
